export const STOREFRONT_REQUEST_GROUP_ID_HEADER =
  'Custom-Storefront-Request-Group-ID';
export const STOREFRONT_ACCESS_TOKEN_HEADER =
  'X-Shopify-Storefront-Access-Token';
export const SDK_VARIANT_HEADER = 'X-SDK-Variant';
export const SDK_VARIANT_SOURCE_HEADER = 'X-SDK-Variant-Source';
export const SDK_VERSION_HEADER = 'X-SDK-Version';
